import React, { Component, Fragment } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { contentActions, messageActions } from '../../../actions'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../../components/SelectWrapped'
import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import Typography from '@material-ui/core/Typography'
import * as API from '../../../api'
import Button from '@material-ui/core/Button'
import FileUpload from 'material-ui/svg-icons/file/file-upload'
import { readOnly } from '../../../utils/permissions'
import EditIcon from 'material-ui/svg-icons/image/edit'
import EditDocumentModal from '../EditDocumentModal'

import {
  IsbnField,
  ISSNField,
  CodigoArtigoField,
  DateField,
  CopyrightField
} from '../../../components/Fields'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  contentForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  },
  uploadButton: {
    margin: '15px 0',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  },
  editButton: {
    margin: '15px 0',
    marginLeft: '10px',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  }
})

class DiagnosticoETratamento extends Component {
  handleChangeFile = e => {
    e.preventDefault()
    const { handleChangeContent, content, getHtmlPreview, changeMessage } = this.props

    let [file] = e.target.files

    if (file) {
      handleChangeContent({
        ...content,
        document: file || ''
      })
      getHtmlPreview({ document: file })
        .then(response => {
          changeMessage({ message: 'Pré-visualização carregada com sucesso.' })
        })
        .catch(error => {
          const { response = {} } = error
          const { status } = response
          if (status === 400) {
            changeMessage({ message: 'Formato de arquivo inválido.' })
          }
        })
    } else {
      handleChangeContent({
        ...content,
        document: file || ''
      })
    }
  }

  componentDidMount() {
    this.props.removeHtmlDocument()
  }

  render() {
    const {
      classes,
      content,
      handleChangeContent,
      contentFormErrors,
      formTouched,
      removeHtmlDocument,
      token,
      openEditDocumentModal
    } = this.props

    const { handleChangeFile } = this

    const isReadOnly = readOnly(content.tipo, token)

    return (
      <Fragment>
        <div>
          <input type="file" id="upload" style={{ display: 'none' }} onChange={handleChangeFile} />
          {!!content.document && (
            <Button
              small
              onClick={() => {
                removeHtmlDocument()
              }}
              color={'secondary'}
              disabled={isReadOnly}
            >
              Remover
            </Button>
          )}
          <Button
            htmlFor="upload"
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.uploadButton}
            disabled={isReadOnly}
          >
            Upload HTML <FileUpload className={classes.uploadButtonIcon} />
          </Button>
          <Button
            onClick={() => openEditDocumentModal()}
            component={'label'}
            variant="raised"
            color={'primary'}
            className={classes.editButton}
            disabled={isReadOnly}
          >
            Editar <EditIcon className={classes.uploadButtonIcon} />
          </Button>
          {!((contentFormErrors.fields || {})['document'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['document'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-titulo">Título</InputLabel>
          <Input
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, titulo: e.target.value })
            }}
            value={content.titulo}
            id="field-titulo"
            disabled={isReadOnly}
          />
          {!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['titulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, autores: obj })
            }}
            error={!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.autores || [])}
            placeholder="Selecione..."
            name="react-select-chip-autores"
            label="Autores"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-autores',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['autores'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, editores: obj })
            }}
            error={!((contentFormErrors.fields || {})['editores'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.editores || [])}
            placeholder="Selecione..."
            name="react-select-chip-label"
            label="Editores"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-label',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['editores'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['editores'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigo">Código D&T</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={CodigoArtigoField}
            onChange={e => {
              handleChangeContent({ ...content, codigo: e.target.value })
            }}
            value={content.codigo || ''}
            id="field-codigo"
          />
          {!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['codigo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['descricao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-descricao">Resumo</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            multiline
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, descricao: e.target.value })
            }}
            value={content.descricao}
            id="field-descricao"
          />
          {!((contentFormErrors.fields || {})['descricao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['descricao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, especialidades: obj })
            }}
            error={!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.especialidades || [])}
            placeholder="Selecione..."
            name="react-select-chip-especialidades"
            label="Especialidades"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-especialidades',
                loadOptions: API.specialities.getSelectSpecialities,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['especialidades'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, palavrasChave: obj })
            }}
            error={!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.palavrasChave || [])}
            placeholder="Selecione..."
            name="react-select-chip-keywords"
            label="Palavras-chave"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-keywords',
                loadOptions: API.keywords.getSelectKeywords,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['palavrasChave'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-pesoDA">Peso DA</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="number"
            onChange={e => {
              handleChangeContent({ ...content, pesoDA: e.target.value })
            }}
            value={content.pesoDA}
            id="field-pesoDA"
          />
          {!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['pesoDA'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>

        <FormControl
          error={!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-idioma">Idioma</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, idioma: e.target.value })
            }}
            value={content.idioma}
            id="field-idioma"
          />
          {!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['idioma'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigoProtheus">Código Protheus</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            inputComponent={IsbnField}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, codigoProtheus: e.target.value })
            }}
            value={content.codigoProtheus || ''}
            id="field-codigoProtheus"
          />
          {!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['codigoProtheus'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-isbn">ISBN</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={IsbnField}
            onChange={e => {
              handleChangeContent({ ...content, isbn: e.target.value })
            }}
            value={content.isbn || ''}
            id="field-isbn"
          />
          {!((contentFormErrors.fields || {})['isbn'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['isbn'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['issn'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-issn">ISSN</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={ISSNField}
            onChange={e => {
              handleChangeContent({ ...content, issn: e.target.value })
            }}
            value={content.issn || ''}
            id="field-issn"
          />
          {!((contentFormErrors.fields || {})['issn'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['issn'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['anoPublicacao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-anoPublicacao">Ano de Publicação</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={CopyrightField}
            onChange={e => {
              handleChangeContent({ ...content, anoPublicacao: e.target.value })
            }}
            value={content.anoPublicacao || ''}
            id="field-anoPublicacao"
          />
          {!((contentFormErrors.fields || {})['anoPublicacao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['anoPublicacao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['dataAtualizacao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-dataAtualizacao">Data de Atualização</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={DateField}
            onChange={e => {
              handleChangeContent({ ...content, dataAtualizacao: e.target.value })
            }}
            value={content.dataAtualizacao || ''}
            id="field-dataAtualizacao"
          />
          {!((contentFormErrors.fields || {})['dataAtualizacao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['dataAtualizacao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <EditDocumentModal content={content} handleChangeContent={handleChangeContent} />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contentFormErrors: state.content.contentFormErrors,
    formTouched: state.content.contentFormTouched,
    conteudoHtml: state.content.conteudoHtml,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    handleChangeContent: content => {
      dispatch(contentActions.handleChangeContent(content))
    },
    setContentFormTouched: () => {
      return dispatch(contentActions.setContentFormTouched())
    },
    removeHtmlDocument: () => {
      return dispatch(contentActions.removeHtmlDocument())
    },
    getHtmlPreview: content => {
      return dispatch(contentActions.getHtmlPreview(content))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    },
    openEditDocumentModal: () => {
      dispatch(contentActions.openEditDocumentModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DiagnosticoETratamento))



// WEBPACK FOOTER //
// ./src/containers/Content/ContentTypes/DiagnosticoETratamento.js